import React, { useState } from 'react';
import { useHistory, Route, Switch, useLocation } from 'react-router-dom';
import { Select } from 'antd';

import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import $ from 'jquery';
import Page404 from '../404/404';

import Default from '../default/default';

import StudentHome from '../studentHome/studentHome';
import StudentJobDetail from '../studentJobDetail/studentJobDetail';
import StudentModule from '../studentModule/studentModule';
import StudentApplyJobDetail from '../studentApplyJobDetail/studentApplyJobDetail';
import StudentModuleDashboard from '../studentModuleDashboard/studentModuleDashboard';
import StudentFillWPA from '../studentFillWPA/studentFillWPA';
import StudentAssignments from '../studentAssignments/studentAssignments';
import WPAManagement from '../WPAManagement/WPAManagement';
import ReviewWPAFormDetail from '../reviewWPAFormDetail/reviewWPAFormDetail';
import StudentSeeAllJobPosting from '../studentSeeAllJobPosting/studentSeeAllJobPosting';
import StudentDetail from '../studentDetail/studentDetail';
import StudentSeeAllJobApplications from '../studentSeeAllJobApplications/studentSeeAllJobApplications';
import StudentResources from '../studentResources/studentResources';
import StudentResourcesContext from '../studentResources/studentResourcesContext';
import KeyDocument from '../keyDocument/keyDocument';

// css
import './newMain.css'

// img
import userImg from '../../public/img/newMain/User.png'
import userSelectedImg from '../../public/img/newMain/UserSelected.png'
import homeIconImg from '../../public/img/newMain/HomeIcon.png'
import selectHomeIconImg from '../../public/img/newMain/SelectHomeIcon.png'
import userLogoImg from '../../public/img/newMain/TheiLogo.png';
import moduleIconImg from '../../public/img/newMain/ModuleIcon.png'
import selectModuleIconImg from '../../public/img/newMain/SelectModuleIcon.png'
import resources from '../../public/img/newMain/resources.png'
import resourcesnoselected from '../../public/img/newMain/resourcesnoselected.png'
import logoImg from '../../public/img/logo.jpg';

export let studentCheckLogin;

const StudentMain = (props) => {

    const location = useLocation();
    const history = useHistory();
    const [sutdentModel, setStudentModel] = useState({})

    studentCheckLogin = () => {
        if (Config.userInfo.userId) {
            searchCohortYear();
            searchStudent();
        } else {
            if (Base.isEmpty(Config.header.authorization)) {
                Config.header.authorization = localStorage.getItem(Config.tokenPrefix + 'AccessToken');
            }
            let token = localStorage.getItem(Config.tokenPrefix + 'RefreshToken');
            if (token) {
                $.ajax({
                    url: Config.apiServer + "student/login/checkToken",
                    type: "POST",
                    data: JSON.stringify(token),
                    async: false,
                    headers: Config.header,
                    contentType: "application/json; charset=utf-8",
                    dataType: 'json',
                    success: (data) => {
                        if ("SUCCESS" === data.msg && data.object.userInfo.userType === 'STUDENT') {
                            Config.userInfo = data.object.userInfo;
                            Config.header.authorization = data.object.accessToken + '';
                            Config.sasToken = data.object.sasToken;
                            localStorage.setItem(Config.tokenPrefix + 'AccessToken', data.object.accessToken);
                            localStorage.setItem(Config.tokenPrefix + 'RefreshToken', data.object.refreshToken);
                            searchCohortYear();
                            searchStudent();
                        } else {
                            Base.removeAllLocalStorage();
                            if (window.location.href.lastIndexOf("/login") === -1) {
                                history.push("/login");
                            }
                        }
                    },
                    error: (jqXHR, textStatus, errorThrown) => {
                    }
                });
            } else {
                history.push("/login");
            }
        }
    }

    const searchCohortYear = () => {
        $.ajax({
            url: Config.apiServer + "student/back/cohort/searchCohortYear",
            type: "POST",
            async: false,
            headers: Config.header,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: (data) => {
                if ("SUCCESS" === data.msg) {
                    Config.cohort = data?.object
                } else {
                    console.log("error", data.msg);
                }
            },
            error: (jqXHR, textStatus, errorThrown) => {
            }
        })
    }

    const searchStudent = () => {
        $.ajax({
            url: Config.apiBackServer + "user/searchStudent",
            type: "POST",
            data: JSON.stringify({ cohortId: Config?.cohort?.cohortId }),
            async: false,
            headers: Config.header,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: (data) => {
                if ("SUCCESS" === data.msg) {
                    Config.studentInfo = data.object;
                    setStudentModel(data.object)
                } else {
                    console.log("error", data.msg);
                }
            },
            error: (jqXHR, textStatus, errorThrown) => {
            }
        })
    }

    const jump = (path) => {
        history.push(path);
    }

    const back = () => {
        history.goBack();
    }

    const logout = () => {
        fetch(Config.apiServer + "student/login/lgout", {
            method: 'POST',
            body: JSON.stringify(Config.userInfo),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                Config.userInfo = {};
                Config.studentInfo = {};
                Config.header.authorization = '';
                Base.removeAllLocalStorage();
                // history.push('/login');
                window.location.replace(Config.logoutUri);
            } else {
                console.log(data.msg);
            }
        }).catch(err => { }).finally(() => {});
    }

    return (
        <div id="newMain">
            {/* 左边菜单区域 */}
            <div id="leftMenu">
                <div className='logoBox'>
                    <img src={logoImg} />
                </div>
                <div className='menuLine'>
                </div>
                <div className='menuFlex'>
                    {/* 添加menu */}
                    <div>
                        {
                            (location.pathname === '/student' || location.pathname === '/student/studentHome' || location.pathname.includes('/student/studentJobDetail')
                                || location.pathname === '/student/studentSeeAllJobPosting' || location.pathname.includes('/student/studentApplyJobDetail')
                                || location.pathname.includes('/student/studentSeeAllJobApplications')
                            ) ?
                                <div className='menuItemSelect'>
                                    <img src={selectHomeIconImg} />
                                </div>
                                :
                                <div className='menuItem'>
                                    <img src={homeIconImg} onClick={() => jump('/student/studentHome')} />
                                </div>
                        }
                        {
                            (location.pathname === '/student/studentModuleDashboard' || location.pathname.includes('/student/studentModule')
                            || location.pathname.includes('keyDocument') || location.pathname.includes('Assignments')
							|| location.pathname.includes('WPA')
                            ) ?
                                <div className='menuItemSelect'>
                                    <img src={selectModuleIconImg} />
                                </div>
                                :
                                <div className='menuItem'>
                                    <img src={moduleIconImg} onClick={() => jump('/student/studentModuleDashboard')} />
                                </div>
                        }
                        {
                            (location.pathname === '/student/resources' || location.pathname.includes('/student/resourcesContext')) ?
                                <div className='menuItemSelect' title='Resources'>
                                    <img src={resources} />
                                </div>
                                :
                                <div className='menuItem' title='Resources'>
                                    <img src={resourcesnoselected} onClick={() => jump('/student/resources')} />
                                </div>
                        }
                    </div>
                    {/* 底部固定menu */}
                    <div>
                        {
                            location.pathname.includes('/student/studentDetail') ?
                                <div className='menuItemSelect'>
                                    <img src={userSelectedImg} />
                                </div>
                                :
                                <div className='menuItem'>
                                    <img src={userImg} onClick={() => jump('/student/studentDetail')} />
                                </div>
                        }
                    </div>
                </div>
            </div>
            {/* 右边内容区域 */}
            <div id="rightMain">
                <div className="head">
                    {location.pathname != '/student/studentHome' && location.pathname != '/student/studentModuleDashboard'
                        && location.pathname != '/student' && location.pathname != '/student/resources' ?
                        <div className='backBox' onClick={() => back()}>
                            &lt;&nbsp;&nbsp;Back
                        </div>
                        :
                        <div className='backBox' onClick={() => jump('/student/resources')}>Resources/FAQ</div>
                    }
                    <div className='selectBox'>
                        <div className='backBox' onClick={() => logout()}>
                            Logout
                        </div>
                        <div className='companySelectBox'>
                            <div className='companySelectImg'>
                                <img src={userLogoImg} />
                            </div>
                            <Select
                                value={sutdentModel?.studentId}
                                options={[
                                    {
                                        value: sutdentModel?.studentId,
                                        label: sutdentModel?.firstName + ' ' + sutdentModel?.lastName,
                                    },
                                ]}
                            />
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/student" exact component={StudentHome} />
                    <Route path="/student/default" exact component={Default} />
                    <Route path="/student/studentHome" exact component={StudentHome} />
                    <Route path="/student/studentJobDetail/:jobId/:flag" exact component={StudentJobDetail} />
                    <Route path="/student/studentModule" exact component={StudentModule} />
                    <Route path="/student/studentApplyJobDetail/:jobApplId" exact component={StudentApplyJobDetail} />
                    <Route path="/student/studentModuleDashboard" exact component={StudentModuleDashboard} />
                    <Route path="/student/studentFillWPA/:wpaApplId?" exact component={StudentFillWPA} />
                    <Route path="/student/studentAssignments" exact component={StudentAssignments} />
                    <Route path="/student/WPAManagement" exact component={WPAManagement} />
                    <Route path="/student/reviewWPAFormDetail" exact component={ReviewWPAFormDetail} />
                    <Route path="/student/studentSeeAllJobPosting" exact component={StudentSeeAllJobPosting} />
                    <Route path="/student/studentDetail" exact component={StudentDetail} />
                    <Route path="/student/studentSeeAllJobApplications/:showStatus" exact component={StudentSeeAllJobApplications} />
                    <Route path="/student/resources" exact component={StudentResources} />
                    <Route path="/student/resourcesContext" exact component={StudentResourcesContext} />
                    <Route path="/student/keyDocument" exact component={KeyDocument} />

                    <Route exact component={Page404} />
                </Switch>
            </div>
        </div>
    )
}

export default StudentMain;